import * as React from 'react';
import { Layout } from '../components/layout';
import { ProdutosPage } from '../pages/produtos/produtos';
import { AuthGuard } from '../guard/auth-guard';

const headerProps = {
  name: 'Chatbot EAD',
};

export const PublicRoutes = [
  {
    routePath: '/',
    isExactPath: true,
    pageToRender: (
      <React.Fragment>
        <AuthGuard>
          <Layout headerProps={headerProps}>
            <ProdutosPage />
          </Layout>
        </AuthGuard>
      </React.Fragment>
    ),
  },
];
